import styled from "styled-components";
import { BaseModalBackground } from "styled-react-modal";

const StyledModalOverlay = styled(BaseModalBackground)`
  background-color: ${({ theme }) => theme.MODAL.OVERLAY_BG}
`;

export default StyledModalOverlay;
